import { render, staticRenderFns } from "./AnswerEdit.vue?vue&type=template&id=4c7d433e&scoped=true&"
import script from "./AnswerEdit.vue?vue&type=script&lang=js&"
export * from "./AnswerEdit.vue?vue&type=script&lang=js&"
import style0 from "./AnswerEdit.vue?vue&type=style&index=0&id=4c7d433e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7d433e",
  null
  
)

export default component.exports